var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    attrs: {
      "id": "encoderInfo"
    }
  }, [_c('el-dialog', {
    attrs: {
      "title": _vm.$t('common.encoderOperationFailed'),
      "custom-class": "encoderInfo",
      "visible": _vm.info.visible,
      "append-to-body": _vm.appendToBody
    },
    on: {
      "update:visible": function ($event) {
        return _vm.$set(_vm.info, "visible", $event);
      },
      "close": _vm.hidePopup
    }
  }, [_c('div', {
    staticClass: "common"
  }, [_vm._v(_vm._s(_vm.$t('common.moreIndex', {
    maxNumber: _vm.info.maxNumber
  })))]), _c('div', {
    staticClass: "common"
  }, [_vm._v(_vm._s(_vm.$t('common.useReceiver')))]), _c('el-table', {
    attrs: {
      "data": _vm.info.data,
      "row-class-name": _vm.addHadStopClass
    }
  }, _vm._l(_vm.tabList, function (item, index) {
    return _c('el-table-column', {
      key: index,
      attrs: {
        "property": item.val,
        "label": item.label
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function (scope) {
          return [_vm.showStopButton(scope.row, index) ? _c('el-button', {
            staticClass: "stopBtn",
            attrs: {
              "loading": scope.row.loading,
              "type": "text",
              "size": "small"
            },
            on: {
              "click": function ($event) {
                return _vm.closeEncoder(scope.row);
              }
            }
          }, [_vm._v(_vm._s(_vm.$t('audioChannels.stop')))]) : _c('div', [_vm._v(_vm._s(_vm.showContent(scope.row, item.val)))])];
        }
      }], null, true)
    }, [_c('template', {
      slot: "header"
    }, [_c('div', [_vm._v(_vm._s(_vm.$t(`common.${item.val}`)))])])], 2);
  }), 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };